import { ExprValue } from './Expr/ExprValue';
export const isAccess = (node) => {
    return node.type === "ACCESS";
};
export const isIdent = (node) => {
    return node.type === "IDENT";
};
export const isParam = (node) => {
    return node.type === "PARAM";
};
export const isCall = (node) => {
    return node.type === "CALL";
};
export const isCase = (node) => {
    return node.type === "CASE";
};
export const isIf = (node) => {
    return node.type === "IF_ELSE";
};
export const isBinary = (node) => {
    return node.type === "BINARY";
};
export const isLogical = (node) => {
    return node.type === "LOGICAL";
};
export const isNullLiteral = (node) => {
    return node.type === "NULL_LITERAL";
};
export const isNumberLiteral = (node) => {
    return node.type === "NUMBER_LITERAL";
};
export const isBooleanLiteral = (node) => {
    return node.type === "BOOLEAN_LITERAL";
};
export const isDateTimeLiteral = (node) => {
    return node.type === "DATE_TIME_LITERAL";
};
export const isStringLiteral = (node) => {
    return node.type === "STRING_LITERAL";
};
export const isLiteralLike = (node) => {
    switch (node.type) {
        case "NULL_LITERAL":
        case "NUMBER_LITERAL":
        case "BOOLEAN_LITERAL":
        case "DATE_TIME_LITERAL":
        case "STRING_LITERAL":
            return true;
        default:
            return false;
    }
};
export const isConstFn = (node) => {
    return isCall(node) && isConst(node);
};
export const isScalarFn = (node) => {
    return isCall(node) && isScalar(node);
};
export const isAggregateFn = (node) => {
    return isCall(node) && isAggregate(node);
};
export const isAnalyticFn = (node) => {
    return isCall(node) && isAnalytic(node);
};
export const isConst = (node) => {
    return node.stage === "CONST";
};
export const isScalar = (node) => {
    return node.stage === "SCALAR";
};
export const isAggregate = (node) => {
    return node.stage === "AGGREGATE";
};
export const isAnalytic = (node) => {
    return node.stage === "ANALYTIC";
};
export const isStringDataType = (type) => {
    return type.name === "STRING";
};
export const isBooleanDataType = (type) => {
    return type.name === "BOOLEAN";
};
export const isDecimalDataType = (type) => {
    return type.name === "DECIMAL";
};
export const isFloatDataType = (type) => {
    return type.name === "FLOAT";
};
export const isIntegerDataType = (type) => {
    return type.name === "INTEGER";
};
export const isNumericDataType = (type) => {
    switch (type.name) {
        case "FLOAT":
        case "INTEGER":
        case "DECIMAL":
            return true;
        default:
            return false;
    }
};
export const isNumericLikeDataType = (type) => {
    return isNumericDataType(type) || isBooleanDataType(type);
};
export const isDateLikeDataType = (type) => {
    switch (type.name) {
        case "DATE_TIME":
        case "TIMESTAMP":
            return true;
        default:
            return false;
    }
};
export const isNullDataType = (type) => {
    return type.name === "NULL";
};
export const getResolvedType = (node) => {
    switch (node.type) {
        case "ACCESS":
        case "BINARY":
        case "CALL":
        case "CASE":
        case "CASE_COND":
        case "CASE_ELSE":
        case "CAST":
        case "IF_ELSE":
        case "IF_COND":
        case "PARAM":
        case "UNARY":
        case "NULL_LITERAL":
        case "BOOLEAN_LITERAL":
        case "STRING_LITERAL":
            return node.data.type.name;
        case "LOGICAL":
            return "BOOLEAN";
        case "DATE_TIME_LITERAL": {
            const dataType = node.data.type.name;
            switch (dataType) {
                case "DATE_TIME":
                case "TIMESTAMP":
                    return dataType;
            }
            return "DATE_TIME";
        }
        case "NUMBER_LITERAL": {
            const dataType = node.data.type.name;
            switch (dataType) {
                case "DECIMAL":
                case "FLOAT":
                case "INTEGER":
                case "TIMESTAMP":
                    return dataType;
            }
            if (ExprValue.isInteger(node.value)) {
                return "INTEGER";
            }
            else {
                return "FLOAT";
            }
        }
        default:
            return node.type;
    }
};
export const nodeResolvesToStringType = (node) => {
    switch (getResolvedType(node)) {
        case "STRING":
        case "STRING_LITERAL":
            return true;
        default:
            return false;
    }
};
export const nodeResolvesToBooleanType = (node) => {
    switch (getResolvedType(node)) {
        case "BOOLEAN":
        case "BOOLEAN_LITERAL":
            return true;
        default:
            return false;
    }
};
export const nodeResolvesToNumericType = (node) => {
    switch (getResolvedType(node)) {
        case "DECIMAL":
        case "FLOAT":
        case "INTEGER":
            return true;
        default:
            return false;
    }
};
export const nodeResolvesToDateLikeType = (node) => {
    switch (getResolvedType(node)) {
        case "DATE_TIME":
        case "TIMESTAMP":
        case "DATE_TIME_LITERAL":
            return true;
        default:
            return false;
    }
};
export const matchesOrIsNull = (types, testDataType) => types.every((type) => testDataType(type) || isNullDataType(type));
